module.exports = __webpack_public_path__ + "img/dy.4b36d962.png";